import { render } from "./WebshopProducts.vue?vue&type=template&id=17d18c3d"
import script from "./WebshopProducts.vue?vue&type=script&lang=js"
export * from "./WebshopProducts.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__